<template>
    <vx-box color="info"
        class="py-4 lg:py-6">
        <div
            class="flex items-center space-x-4 text-slate-800  font-extrabold px-4 pb-4 lg:px-9 lg:text-xl">
            <font-awesome-icon widthAuto :icon="faBarsFilter"
                class="text-base ml-2" />

            <span>Contact Filters</span>

            <vx-badge color="primary"
                size="xs"
                data-test="filters-count">
                {{ filtersCount }}
            </vx-badge>

        </div>
        <segment-step-form-filter-group v-for="(group, groupIndex) in groups"
            :key="group.id"
            v-model="groups[groupIndex]"
            @createGroup="createGroup()"
            @removeGroup="removeGroup(groupIndex)"
            :isLast="(groupIndex + 1) == groups.length">
        </segment-step-form-filter-group>
        <div v-if="props.error" class="relative px-7 pt-4 text-xs text-rose-800">
            {{ props.error }}
        </div>
    </vx-box>
</template>


<script setup>
import { computed, watch } from 'vue';
import SegmentStepFormFilterGroup from './SegmentStepFormFilterGroup.vue';
import { faBarsFilter } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge, VxBox } from '@voxie/frontend-components';
import { makeGroup } from './segmentFiltersHelpers';

const groups = defineModel({
    type: Array,
    required: true,
    default: () => ([]),
})

const props = defineProps({
    error: String,
});

const createGroup = () => {
    groups.value.push(makeGroup());
}

const removeGroup = (groupIndex) => {
    if (groups.value.length === 1) {
        return;
    }

    groups.value = groups.value.filter((group, currentIndex) => currentIndex != groupIndex)
}

const filtersCount = computed(() => {
    return groups.value.reduce((acc, group) => {
        return acc + group.filters.length
    }, 0)
})

watch(() => groups.value, (newGroups) => {
    if (!newGroups?.length) {
        groups.value = [makeGroup()];
    }
}, {
    immediate: true,
})

</script>
